import XLSX from 'xlsx'

/**
 * Sheep Utilities
 */
export default class Utils {
  /**
     * Loads a file
     *
     * @param  {[type]}
     * @return {[type]}
     */
  static loadFile (file, callback) {
    var rABS = true // true: readAsBinaryString ; false: readAsArrayBuffer
    var reader = new FileReader()

    reader.onload = (e) => {
      // console.log('Loaded File')
      var data = !rABS ? new Uint8Array(e.target.result) : e.target.result
      callback(XLSX.read(data, { type: rABS ? 'binary' : 'array' }))
    }

    if (rABS) {
      reader.readAsBinaryString(file)
    } else {
      reader.readAsArrayBuffer(file)
    }
  }

  static sheetToArray (sheet) {
    return XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false })
  }

  static arrayToCsv (sheet) {
    return XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(sheet))
  }
}
